import React, { useEffect, useState } from 'react';
import CreateLeaderboardPage from './CreateLeaderboardPage';
import { useParams } from 'react-router-dom';
import api, { CreateLeaderboardRequest, LeaderboardDto } from '../../../api';
import { useSelector } from 'react-redux';
import { projectSelector } from '../../../redux/selectors/projectSelector';

type ParamsProps = {
	projectId: string;
	apiName: string;
};

export default function EditLeaderboardPage() {
	const [leaderboard, setLeaderboard] = useState<CreateLeaderboardRequest>();
	const apiName = useParams<ParamsProps>().apiName;
	const project = useSelector(projectSelector);
	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		const getLeaderboard = async () => {
			if (project?.productId) {
				setLoading(true);
				const leaderboard = await api
					.getLeaderboardDefinition(project.productId, apiName)
					.finally(() => {
						setLoading(false);
					});

				const leaderboardRequest: CreateLeaderboardRequest = {
					...leaderboard,
					productId: project.productId,
				};
				delete leaderboardRequest.gameStatApiName;
				setLeaderboard(leaderboardRequest);
			}
		};

		getLeaderboard();
	}, []);

	return <CreateLeaderboardPage leaderboard={leaderboard} loading={loading} />;
}
